import { GetPersonUser, PersonBenefits } from '@esportal/portal-service';
import { getUserName, getSurname1, getSurname2, getEmail } from '../../../../../helpers/nameHelper';
import { discountHelper } from '../../../../../helpers/discountHelper';
import { HuchaType, HuchaValues, HuchaVentaValues, HuchaPosventaValues } from '../models/hucha-values';
import { getHuchaTierFromDiscounts } from '../../hucha-venta/helpers/get-renovador-tier';
import React from 'react';

export const HuchaDiscountNameByType: Record<HuchaType, string> = {
	venta: 'moneybox',
	posventa: 'bonoTaller50',
};

export const hasHucha = (personBenefits: PersonBenefits): boolean => {
	const discounts = personBenefits.benefits.discounts ?? [];

	return discounts.some(
		({ name }) => name === HuchaDiscountNameByType.venta || name === HuchaDiscountNameByType.posventa,
	);
};

export const useHuchaValues = (
	userData: GetPersonUser | null,
	personBenefits: PersonBenefits,
	huchaType: HuchaType,
): HuchaValues | null => {
	const { formatNumberWithThousands } = discountHelper();
	const discounts = personBenefits.benefits.discounts ?? [];

	return React.useMemo(() => {
		const getDiscountByName = (name: string) => discounts.find((discount) => discount.name === name);

		// datos base
		const baseData = {
			idUser: userData?.portalUser?.data?.clubVW?.idMember || '',
			name: userData ? getUserName(userData) : '',
			apellido1: userData ? getSurname1(userData) : '',
			apellido2: userData ? getSurname2(userData) : '',
			email: userData ? getEmail(userData) : '',
			fechaDescarga: new Date().toLocaleDateString('es-ES', { day: 'numeric', month: 'numeric', year: 'numeric' }),
		};

		const huchaDiscount = getDiscountByName(HuchaDiscountNameByType[huchaType]);

		if (!huchaDiscount) {
			return null;
		}

		const rawHuchaValue = huchaDiscount?.value.toString() || '0';
		const dineroHucha = formatNumberWithThousands(rawHuchaValue);

		// rama posventa
		if (huchaType === 'posventa') {
			return {
				...baseData,
				huchaType,
				dineroHucha,
				status: huchaDiscount.voucher?.status,
				expirationDate: huchaDiscount.voucher?.vgedExpirationDate,
			} as HuchaPosventaValues;
		}

		// rama venta
		const huchaTier = getHuchaTierFromDiscounts(discounts);

		// hucha venta estándar
		if (huchaTier === 'standard') {
			return {
				...baseData,
				huchaType,
				huchaTier,
				dineroHucha,
			} as HuchaVentaValues;
		}

		// hucha venta renovadores
		const renovadoresRaw = getDiscountByName(huchaTier)?.value.toString() || '0';
		const dineroRenovadores = formatNumberWithThousands(renovadoresRaw);

		const huchaNum = parseInt(rawHuchaValue.replace(/\./g, '')) || 0;
		const renoNum = parseFloat(renovadoresRaw) || 0;
		const descuentoTotal = formatNumberWithThousands((huchaNum + renoNum).toString());

		return {
			...baseData,
			huchaType,
			huchaTier,
			dineroHucha,
			dineroRenovadores,
			descuentoTotal,
		} as HuchaVentaValues;
	}, [userData, discounts, huchaType, formatNumberWithThousands]);
};
